module.exports = __webpack_public_path__ + "img/index-title.682a23e8.png";